export default __webpack_public_path__ + "static/media/Icon6.4880d0e1.png";